import { Card, message, Modal, Select, Typography } from 'antd';
import {
  CollaborationRequest,
  CollaborationTicket,
  OrganizationUnitChildren,
  TicketDetail,
  TransferTicket,
  TransferTicketRequest
} from 'types';
import { requestform } from 'messages';
import React, { useEffect, useState } from 'react';
import { GetOrganizationUnitChildren } from 'hooks/request-form';
import { RootState } from 'store';
import { useSelector } from 'react-redux';
import { usePatchCollaborationTicketsMutation, usePatchTranferTicketsMutation } from 'services';
import TextArea from 'antd/es/input/TextArea';

const { Option } = Select;

interface ticketDetail {
  requestItem: TicketDetail | null;
  processingContent: string;
  cancelDetailModal: () => void;
  isProcessingRoomTransfer?: boolean;
}

const ModalTransferUnit: React.FC<ticketDetail> = ({
  requestItem,
  processingContent,
  cancelDetailModal,
  isProcessingRoomTransfer
}) => {
  const [originalList, setOriginalList] = useState<OrganizationUnitChildren[]>([]);
  const [filteredList, setFilteredList] = useState(originalList);
  const ticketId = requestItem?.ticketId || 0;

  const { data: organizationUnitChildrenList } = GetOrganizationUnitChildren(
    Number(requestItem?.organizationUnit.organizationUnitId || 0)
  );
  const profile = useSelector((state: RootState) => state.users.userProfile);
  const [collaboration] = usePatchCollaborationTicketsMutation();
  const [transfer] = usePatchTranferTicketsMutation();

  useEffect(() => {
    const updatedList = organizationUnitChildrenList.filter((unit) => unit.name !== profile?.organizationUnit?.name);
    setOriginalList(updatedList);
    setFilteredList(updatedList);
  }, [originalList]);

  const [collaborationUnit, setCollaborationUnit] = useState<number>(0);
  const chooseCollaborationUnit = (toUnitId: number) => setCollaborationUnit(toUnitId);

  const [requestContent, setRequestContent] = useState<string>('');
  useEffect(() => {
    setRequestContent(processingContent ? processingContent : '');
  }, []);
  const sendTransferUnitRequestTickets = () => {
    if (collaborationUnit == 0) {
      message.error('Vui lòng chọn phòng/đội');
      return;
    }

    if (!requestContent || requestContent.trim() === '' || requestContent.trim() === 'Nội dung phản hồi') {
      message.error('Vui lòng nhập nội dung xử lý', 2);
      return;
    }

    Modal.confirm({
      title: 'Xác nhận cập nhật phiếu',
      okText: 'Xác nhận',
      cancelText: 'Hủy',
      onOk() {
        if (ticketId) {
          if (isProcessingRoomTransfer) {
            // 👉 gọi API chuyển phòng xử lý
            const transferDetail: TransferTicket = {
              processingContent: requestContent,
              toTeamId: collaborationUnit
            };
            const transferTicketRequest: TransferTicketRequest = {
              transferDetail,
              ticketId
            };
            transfer(transferTicketRequest)
              .unwrap()
              .then(() => {
                message.success('Chuyển phiếu về phòng xử lý thành công', 2);
                cancelDetailModal();
              })
              .catch(() => message.error('Chuyển phiếu thất bại', 2));
          } else {
            // 👉 gọi API chuyển phối hợp như hiện tại
            const fromTeamId = profile?.organizationUnitId || 0;
            const collaborationDetail: CollaborationTicket = {
              fromTeamId,
              processingContent: requestContent,
              collaborationTeamId: collaborationUnit
            };

            const collaborationRequest: CollaborationRequest = {
              collaborationDetail,
              ticketId
            };

            collaboration(collaborationRequest)
              .then(() => {
                message.success('Chuyển phối hợp thành công', 2);
                cancelDetailModal();
              })
              .catch(() => message.error('Chuyển phối hợp thất bại', 2));
          }
        }
      }
    });
  };

  return (
    <Card className='confirm-modal mx-auto bg-[#F5F5F7] py-4 text-center'>
      {/** --- Card Title  --- */}
      <div className='ml-6 flex justify-start'>
        <Typography.Text className='text-[26px]/[34px] font-bold text-[#141414]'>
          {isProcessingRoomTransfer
            ? requestform.chooseProcessingRoom // 👈 thêm key text mới nếu chưa có
            : requestform.chooseOrganizationUnit}
        </Typography.Text>
      </div>

      <div className={'mx-6 my-4 mb-0 space-y-4'}>
        {/** --- Choose Transfer Unit  ---*/}
        <div className='space-y-1 text-left'>
          <Typography.Text className='text-[14px]/[16px] font-semibold'>
            {isProcessingRoomTransfer
              ? requestform.chooseProcessingRoom // 👈 thêm key text mới nếu chưa có
              : requestform.chooseOrganizationUnit}
          </Typography.Text>
          <Select
            className='w-full'
            placeholder='Chọn phòng/đội'
            onChange={(value: number) => chooseCollaborationUnit(value)}
            showSearch
            filterOption={false}
          >
            {filteredList.map((unit) => (
              <Option key={unit.organizationUnitId} value={unit.organizationUnitId}>
                {unit.name}
              </Option>
            ))}
          </Select>
        </div>

        {/** --- Processing Content  ---*/}
        <div className='space-y-1 text-left'>
          <Typography.Text className='text-[14px]/[16px] font-semibold'>
            {requestform.processingContentTitle}
          </Typography.Text>
          <TextArea
            placeholder={'Nhập nội dung phản hồi'}
            value={requestContent}
            onChange={(e) => {
              setRequestContent(e.target.value);
            }}
            autoSize={{ minRows: 5, maxRows: 10 }}
            className='rounded-lg bg-[#F7F8F6]'
          />
        </div>

        {/** --- Confirm Button  ---*/}
        <div className={'flex justify-end'}>
          <button
            onClick={sendTransferUnitRequestTickets}
            className='rounded-lg bg-[#28A745] px-6 py-[10px] text-[16px]/[20px] font-semibold text-[#FFFFFF]'
          >
            {requestform.confirmButton}
          </button>
        </div>
      </div>
    </Card>
  );
};

export default ModalTransferUnit;
